import React, { useState, useEffect } from "react";
import { Loader, Confirm, Grid } from "semantic-ui-react";
import { RegisteredDocument } from "../../../../api";
import { useAuth } from "../../../../hooks";
import { CustomTable, BasicModal } from "../../../Shared";
import { RegisteredDocumentForm } from "../RegisteredDocumentForm";
import { buildStorageUrl } from "../../../../utils";
import "./ListRegisteredDocument.scss";

const registeredDocumentController = new RegisteredDocument();

export function ListRegisteredDocument(props) {
  const { studentActive, onReload } = props;
  const { accessToken } = useAuth();

  const [reloadDocument, setReloadDocument] = useState(null);
  const onReloadDocument = () => setReloadDocument((prevState) => !prevState);

  const [registeredDocuments, setRegisteredDocuments] = useState(null);
  const [registeredDocumentActive, setRegisteredDocumentActive] =
    useState(null);
  const [loading, setLoading] = useState(false);
  const [showConfirm, setShowConfirm] = useState(false);
  const [showModal, setShowModal] = useState(false);

  const onOpenCloseConfirm = (row) => {
    setRegisteredDocumentActive(row);
    setShowConfirm((prevState) => !prevState);
  };

  const onOpenCloseModal = (row) => {
    setRegisteredDocumentActive(row);
    setShowModal((prevState) => !prevState);
  };

  const getDocumentPath = (row) => {
    return buildStorageUrl(row?.path);
  };

  const onOpenCloseModalDocument = (row) => {
    setRegisteredDocumentActive(row);
    const documentPath = getDocumentPath(row);
    window.open(documentPath, "_blank");
  };

  const onDelete = async () => {
    try {
      await registeredDocumentController.deleteRegisteredDocument(
        accessToken,
        registeredDocumentActive.id
      );
      onReloadDocument();
      onOpenCloseConfirm();
    } catch (error) {
      console.error(error);
    }
  };

  const tableConfig = {
    headers: ["Documento", "Comentario", "Fecha de registro", "Acciones"],
    fields: [
      {
        field: "Document.name",
        dataType: "text",
        align: "center",
      },
      {
        field: "comment",
        dataType: "text",
      },
      {
        field: "uploadDate",
        dataType: "date",
        format: "DD/MM/YYYY",
        align: "center",
      },
      {
        buttons: [
          {
            color: "blue",
            icon: "pencil",
            placeholder: "Editar documento",
            onClick: onOpenCloseModal,
          },
          {
            color: "green",
            icon: "eye",
            placeholder: "Ver documento",
            onClick: onOpenCloseModalDocument,
          },
          {
            color: "red",
            icon: "trash",
            placeholder: "Eliminar documento",
            onClick: onOpenCloseConfirm,
          },
        ],
      },
    ],
    columnWidths: ["30%", "30%", "20%", "20%"],
  };

  useEffect(() => {
    (async () => {
      setLoading(true);
      try {
        const response =
          await registeredDocumentController.getRegisteredDocuments(
            studentActive.id,
            accessToken
          );
        setRegisteredDocuments(response);
      } catch (error) {
        console.error(error);
      }
      setLoading(false);
    })();
  }, [studentActive, reloadDocument, accessToken]);

  return (
    <>
      <Grid columns={2} stackable>
        <Grid.Row>
          <Grid.Column width={5}>
            <RegisteredDocumentForm
              studentActive={studentActive}
              onReload={onReloadDocument}
              setLoading={setLoading}
            />
          </Grid.Column>
          <Grid.Column width={11}>
            <CustomTable
              color="teal"
              tableConfig={tableConfig}
              data={registeredDocuments}
              loading={loading}
            />
          </Grid.Column>
        </Grid.Row>
      </Grid>
      <BasicModal
        title={`Actualizar ${registeredDocumentActive?.Document?.name}`}
        show={showModal}
        close={onOpenCloseModal}
      >
        {registeredDocumentActive && (
          <div className="document__form">
            <RegisteredDocumentForm
              studentActive={studentActive}
              registeredDocument={registeredDocumentActive}
              onReload={onReloadDocument}
              onClose={onOpenCloseModal}
              setLoading={setLoading}
            />
          </div>
        )}
      </BasicModal>
      <Confirm
        confirmButton="Aceptar"
        cancelButton="Cancelar"
        open={showConfirm}
        onCancel={onOpenCloseConfirm}
        onConfirm={onDelete}
        content={`¿Eliminar documento ${registeredDocumentActive?.Document?.name}?`}
        size="mini"
      />
    </>
  );
}
